import { z } from 'zod'
import type { TransitionTable } from '../helpers/state-machine.js'

/**
 * Lifecycle of a temporary Prism import job. Mirrors `PrismImportJobStatus` in
 * the Prisma schema.
 */
export const PRISM_IMPORT_JOB_STATUSES = [
  'queued',
  'running',
  'succeeded',
  'failed',
  'cancelled',
] as const

export const prismImportJobStatusSchema = z.enum(PRISM_IMPORT_JOB_STATUSES)

export type PrismImportJobStatus = z.infer<typeof prismImportJobStatusSchema>

/**
 * The moves an import job may make. It moves on its own, through the runner,
 * rather than by a person, so the value of the table is less audit than refusing
 * an impossible move — a job going from `failed` back to `running`, say.
 *
 * A queued job can fail or be canceled without ever running (the importer has no
 * Social Tables credentials, a restart, a cancel before its turn), but it cannot
 * succeed: only a run produces a result. The three endings are terminal; running
 * an import again is a new job.
 */
export const PRISM_IMPORT_JOB_TRANSITIONS: TransitionTable<PrismImportJobStatus> = {
  queued: ['running', 'failed', 'cancelled'],
  running: ['succeeded', 'failed', 'cancelled'],
  succeeded: [],
  failed: [],
  cancelled: [],
}
